import { cn } from "../lib/utils";

export interface StepsIndicatorProps {
  steps: string[];
  current: number;
}

export function StepsIndicator({ steps, current }: StepsIndicatorProps) {
  return (
    <div className="flex items-center mb-6">
      {steps.map((label, i) => {
        const idx = i + 1;
        const state =
          idx < current ? "done" : idx === current ? "active" : "default";
        return (
          <div key={label} className="flex items-center flex-1 last:flex-none">
            <div
              className={cn(
                "flex items-center gap-1.5 text-[11px] font-medium",
                state === "active" && "text-primary",
                state === "done" && "text-success",
                state === "default" && "text-ink-subtle",
              )}
            >
              <span
                className={cn(
                  "w-5 h-5 rounded-pill border-[1.5px] flex items-center justify-center text-[10px] font-semibold transition-colors",
                  state === "active" &&
                    "border-primary bg-primary text-white",
                  state === "done" && "border-success bg-success text-white",
                  state === "default" &&
                    "border-border-strong text-ink-subtle",
                )}
              >
                {state === "done" ? (
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polyline points="2,5 4,7 8,3" />
                  </svg>
                ) : (
                  idx
                )}
              </span>
              <span>{label}</span>
            </div>
            {i < steps.length - 1 && (
              <div
                className={cn(
                  "flex-1 h-px mx-2.5 transition-colors",
                  state === "done" ? "bg-success" : "bg-border-strong",
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
